import { token } from '@atlaskit/tokens';

type IconProps = {
	width?: string | number;
	height?: string | number;
};

export const PipelineAnalyzerIcon = ({ width = '23', height = '26' }: IconProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 23 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.0872 1.18645C11.7236 0.977484 11.2764 0.977484 10.9128 1.18645L1.46037 6.61868C1.09457 6.8289 0.869048 7.21862 0.869048 7.64052V18.4966C0.869048 18.9185 1.09457 19.3082 1.46037 19.5185L10.9128 24.9507C11.2764 25.1597 11.7236 25.1597 12.0872 24.9507L21.5396 19.5185C21.9054 19.3082 22.131 18.9185 22.131 18.4966V7.64052C22.131 7.21862 21.9054 6.8289 21.5396 6.61868L12.0872 1.18645Z"
				fill="#82B536"
				stroke={token('color.border')}
				strokeWidth="0.261905"
			/>
			<mask id="mask0_1374_5992" maskUnits="userSpaceOnUse" x="1" y="1" width="21" height="24">
				<path
					d="M10.978 1.29999C11.3012 1.11424 11.6988 1.11424 12.022 1.29999L21.4744 6.73221C21.7995 6.91908 22 7.2655 22 7.64052V18.4966C22 18.8716 21.7995 19.2181 21.4744 19.4049L12.022 24.8372C11.6988 25.0229 11.3012 25.0229 10.978 24.8372L1.52562 19.4049C1.20047 19.2181 1 18.8716 1 18.4966V7.64052C1 7.2655 1.20047 6.91908 1.52562 6.73222L10.978 1.29999Z"
					fill="#FFA900"
				/>
			</mask>
			<g mask="url(#mask0_1374_5992)">
				<path
					d="M13.513 6.19383C13.9794 6.41389 14.3759 6.70366 14.6568 7.01257L14.6608 6.9866C15.7415 7.47593 16.6098 8.42179 17.1259 9.51664C16.8948 9.49477 16.4015 9.14896 16.2052 9.23233C14.759 8.64869 16.8061 9.99777 17.4082 9.9513L17.4042 9.94719C17.4042 9.94719 17.5346 9.95813 17.5265 9.9718C18.0722 9.31707 18.0749 6.30317 17.4405 8.98357C17.2657 8.61862 16.9136 8.01037 16.7711 7.84771C16.4606 7.62902 16.4189 7.34062 16.0506 7.2094C16.0506 7.2094 16.1232 7.19163 16.1246 7.19026C15.259 6.32915 13.8826 5.41745 12.642 5.21379C12.6662 5.27804 13.2051 5.50494 13.2535 5.54458C12.8839 5.60882 11.3341 5.05797 12.4148 5.17962C12.0277 4.85841 9.19967 5.01561 9.947 5.27941C9.81797 5.31358 9.28436 5.52954 9.55319 5.31904C8.6244 5.13589 5.24526 8.06231 6.23991 8.32885C6.3891 8.01447 6.82191 7.81901 6.91466 7.56068C6.86761 7.45817 6.83805 7.39939 6.93886 7.33925C7.27892 7.57708 7.70366 6.57381 7.87436 6.5205C7.93619 6.7556 9.33541 5.57738 9.12035 5.9601C10.4954 5.66896 12.1809 5.5104 13.5157 6.18973L13.513 6.19383Z"
					fill="#B3DF72"
				/>
				<path
					d="M19.9461 13.8634C19.9797 13.4916 18.9649 11.7516 18.9824 12.5129C18.9797 12.625 19.2338 13.2401 19.3292 13.3973C19.4381 13.4014 19.5026 13.4 19.5052 13.5148C19.1504 13.7171 19.7015 14.3937 19.6679 14.6971C19.4381 16.3442 17.8923 19.5522 15.4379 19.3923C15.3196 19.3813 14.9541 19.5399 14.8425 19.5207C13.8223 19.6397 11.3115 18.974 13.333 18.4204C14.0024 17.7356 11.7914 18.6719 11.5723 18.9275C11.79 20.0647 13.5293 21.5382 12.2591 19.4401C12.9446 19.8337 13.5051 20.17 14.278 20.0866C15.1476 20.4912 17.1302 19.9718 17.9286 19.1476C17.8762 19.1394 17.3721 19.3991 17.3197 19.4114C17.5428 19.0546 18.7498 18.2837 18.0993 18.9945C19.7136 17.5402 20.176 16.1241 19.9448 13.8606L19.9461 13.8634Z"
					fill="#B3DF72"
				/>
				<path
					d="M9.22481 18.177C9.13475 18.1456 8.51781 18.1688 8.37533 18.2057C8.33904 18.3069 8.32426 18.3739 8.22479 18.337C8.03796 17.8886 7.17368 18.337 6.87663 17.9925C5.74085 17.5155 3.01095 15.6634 3.82818 13.6637C3.78382 12.6905 4.2892 11.6982 4.96395 10.9929C5.17095 10.6635 5.02981 11.7897 5.21665 11.8335C5.37929 13.4218 5.60644 10.9081 5.2852 10.4215C5.2852 10.4215 5.23412 10.2999 5.25025 10.2999C4.25694 10.1331 2.19103 11.4043 4.39405 10.8412C3.92629 11.3701 3.55128 11.7515 3.45451 12.4486C2.88729 13.0787 2.80663 15.0729 3.4666 15.9354C3.46929 15.8438 3.33354 15.3231 3.3416 15.3272C3.6279 15.5937 4.12792 16.8102 3.57952 16.1172C3.77173 17.5209 8.95464 19.7407 9.22481 18.1757V18.177Z"
					fill="#B3DF72"
				/>
			</g>
			<path
				d="M7.47953 7.75586H13.4597C15.1684 7.75586 16.5544 9.14194 16.5544 10.8506C16.5544 12.5592 15.1684 13.9453 13.4597 13.9453H9.74608C8.94988 13.9453 8.30188 14.5904 8.30188 15.3895C8.30188 16.1886 8.94697 16.8337 9.74608 16.8337H15.7263V18.4842H9.74608C8.03745 18.4842 6.65137 17.0981 6.65137 15.3895C6.65137 13.6808 8.03745 12.2948 9.74608 12.2948H13.4597C14.2559 12.2948 14.9039 11.6497 14.9039 10.8506C14.9039 10.0515 14.2588 9.40637 13.4597 9.40637H7.47953V7.75586Z"
				fill="#101214"
			/>
			<path
				d="M7.47967 11.0365C8.847 11.0365 9.95544 9.92806 9.95544 8.56073C9.95544 7.1934 8.847 6.08496 7.47967 6.08496C6.11235 6.08496 5.00391 7.1934 5.00391 8.56073C5.00391 9.92806 6.11235 11.0365 7.47967 11.0365Z"
				fill="white"
			/>
			<path d="M18.0018 15.3779H13.4629V19.9168H18.0018V15.3779Z" fill="white" />
			<path
				d="M9.81771 7.75586C9.90488 8.00867 9.95138 8.276 9.95138 8.55787C9.95138 8.85717 9.89907 9.14194 9.80028 9.40637H7.47852V7.75586H9.81771Z"
				fill="#82B536"
			/>
			<path
				d="M9.95138 8.55787C9.95138 8.85717 9.89907 9.14194 9.80028 9.40637H7.47852V7.75586H9.81771C9.90488 8.00867 9.95138 8.276 9.95138 8.55787Z"
				fill="#82B536"
			/>
			<path
				d="M15.2916 19.5625V18.4815H13.4609V16.831H15.2916V15.75L17.1949 17.6562L15.2916 19.5625Z"
				fill="#82B536"
			/>
		</svg>
	);
};
